import {NgModule, ModuleWithProviders} from '@angular/core';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {AuthRoutingModule} from './auth-routing.module';
import {SharedModule} from '../shared/shared.module';

// MODULES
const MODULES = [
    SharedModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    FormsModule
];

// MODULES_WITH_PROVIDERS
const MODULES_WITH_PROVIDERS: ModuleWithProviders[] = [];

// COMPONENTS
import {LoginComponent} from './components/login/login.component';
import {RegisterComponent} from './components/register/register.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {LoginAdminComponent} from './components/login/login.admin.component';
import {RegisterYettelComponent} from './components/register-yettel/register-yettel.component';

// ENTRY COMPONENTS
const ENTRY_COMPONENTS = [];

// COMPONENTS
const COMPONENTS = [
    ...ENTRY_COMPONENTS,
    LoginComponent,
    LoginAdminComponent,
    RegisterComponent,
    RegisterYettelComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
];

// EVENT EMITTERS
const EVENT_EMITTERS = [];

// SERVICES
const SERVICES = [];

// DIRECTIVES
const DIRECTIVES = [];

// PIPES
const PIPES = [];

@NgModule({
    imports: [
        ...MODULES,
        ...MODULES_WITH_PROVIDERS
    ],
    declarations: [
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES
    ],
    providers: [
        ...SERVICES,
        ...EVENT_EMITTERS
    ]
})
export class AuthModule {
}
